import React, { useState } from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { BsGithub } from 'react-icons/bs';
import { BsDribbble } from 'react-icons/bs';
import { IoIosColorPalette } from "react-icons/io";

const HeaderSocials = () => {
	const [toggleColor,setToggleColor] = useState(false)
	const handleColor = ()=>{
		setToggleColor(!toggleColor)
	}
	const toggleTheme = () => {
		document.body.classList.toggle('green-theme');
	  };
	return (
		<div className='header__socials'>
			<a href='https://www.linkedin.com/in/mahmoud-sabry-69b68021b/' target='_blank' rel='noopener noreferrer'>
				<BsLinkedin />
			</a>
			<a
				href='https://github.com/mahmoudsabry12'
				target='_blank'
				rel='noopener noreferrer'
			>
				<BsGithub />
			</a>
			<a href='https://dribble.com/' target='_blank' rel='noopener noreferrer'>
				<BsDribbble />
			</a>
			{/* <a  target='_blank' rel='noopener noreferrer'>
			<IoIosColorPalette onClick={handleColor} style={{position:'relative',cursor:'pointer'}}/>
			{toggleColor && (
				<div className='colors' style={{display:"flex", gap:"0.4rem",position:"absolute",left:'20px',bottom:'53px'}}>
				<button style={{backgroundColor:"green",width:"15px",height:'15px',borderRadius:"50%", cursor:'pointer'}} onClick={toggleTheme}></button>
				<button style={{backgroundColor:"red",width:"15px",height:'15px',borderRadius:"50%", cursor:'pointer'}}></button>
				<button style={{backgroundColor:"blue",width:"15px",height:'15px',borderRadius:"50%", cursor:'pointer'}}></button>

			</div>
			)}
			</a> */}
		</div>
	);
};

export default HeaderSocials;
